import { WSAPI } from './WSApi';
import Proxy from '@/sdk/common/Proxy';
export class PromotionApi extends WSAPI {
  private readonly headerBanners = [
    {
      Id: 0,
      Image: '/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtItem/220adf20-0505-4d7b-9b6a-b4db538d50a6/4984bed1-baae-401f-a889-c4432493693b.jpg',
      Seq: 1,
      Url: '',
      Content: '',
      IsRedirect: true
    },
    {
      Id: 0,
      Image: '/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtItem/220adf20-0505-4d7b-9b6a-b4db538d50a6/72de305c-42f5-46ac-bd2f-668fc6c0fc4f.jpg',
      Seq: 2,
      Url: '',
      Content: '',
      IsRedirect: true
    },
    {
      Id: 0,
      Image: '/nci/ClientResources/68973b3a-ed23-4aa3-a357-90cfb5ce03e6/prmtItem/220adf20-0505-4d7b-9b6a-b4db538d50a6/bfa3fdc4-f10d-48f2-943c-e9ffcbd4d82f.png',
      Seq: 3,
      Url: '',
      Content: '',
      IsRedirect: true
    }
  ];

  /**
   * 獲取指定頁面的頂部廣告橫幅
   * @param page: string 頁面名稱
   * @returns 橫幅信息列表
   */
  getHeaderBanner (page: string) {
    return Promise.resolve(this.headerBanners);
  };

  /**
   * 獲取指定頁面及位置的推廣資料列表
   * @param page: string 頁面名稱
   * @returns 推廣資料列表
   */
  getPromotionList (page: string) {
    return this.instance.get(this.apiPath + '/Banner/getPromotionList', { params: { page: page } }).then(res => res.data);
  };

  /**
   * 獲取指定頁面及位置的推廣資料
   * @param page: string 頁面名稱
   * @param position: number 位置名稱
   * @returns 推廣資料
   */
  @Proxy('Promotion')
  getPromotion (page: string, position: number) {
    return this.instance.get(this.apiPath + '/Banner/GetPromotion', { params: { page: page, position: position } }).then(res => res.data);
  }

  /**
   * 獲取首頁的SEO數據
   */
  getHomeSeoData () {
    return this.instance.get(this.apiPath + '/seo/GetHomeSeoData').then(res => res.data);
  };

  /**
   * 獲取菜單數據
   */
  getMenu () {
    return this.instance.get(this.apiPath + '/Menu').then(res => res.data);
  };

  private static instance: PromotionApi;
  //* * 单例 */
  public static getInstance (): PromotionApi {
    if (PromotionApi.instance) { return PromotionApi.instance; } else {
      PromotionApi.instance = new PromotionApi();
      return PromotionApi.instance;
    }
  }
}
